import { cn } from "@/lib/utils";

type Step = {
  title: string;
};

type StepperProps = {
  steps: Step[];
  currentStep: number;
};

export function Stepper({ steps, currentStep }: StepperProps) {
  return (
    <div className="relative flex items-center justify-between">
      {/* Line Background */}
      <div className="absolute top-4 left-8 right-8 h-0.5 bg-[#DECEBE] z-0" />

      {/* Line Fill */}
      {/* <div
        className="absolute top-4 left-4 h-0.5 bg-primary z-0 transition-all duration-300"
        style={{
          width:
            steps.length > 1
              ? `calc(${currentStep / (steps.length - 1)} * (100% - 2rem))`
              : "0%",
        }}
      /> */}

      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;

        return (
          <div key={index} className="z-10 flex flex-col items-center">
            {/* Circle */}
            <div
              className={cn(
                "w-8 h-8 rounded-full border-2 flex items-center justify-center text-sm",
                isCompleted
                  ? "bg-primary text-[white] border-primary"
                  : isActive
                    ? "bg-primary text-white border-primary"
                    : "bg-[#FDFAF7] text-[#DECEBE] border-[#DECEBE]",
              )}
            >
              {index + 1}
            </div>

            {/* Label */}
            <div className="mt-2 text-center text-xs">{step.title}</div>
          </div>
        );
      })}
    </div>
  );
}
